"use client";

import React from "react";
import type { TagProps } from "@/components/user/Tags.js";
import { PopupButton } from "@/components/generic/popup/PopupButton.js";
import { Pill } from "@rosette/web_components/src/ui/Pill.js";


interface ProfileBadgesProps {
    badges: TagProps[];
}


// Profile badges render as pills that open a popup with the badge's description
// when tapped (the in-game popup uses the simpler native-title Tags instead).
export function ProfileBadges({ badges }: ProfileBadgesProps) {
    if (badges.length === 0)
        return null;

    return (
        <div className="flex flex-row flex-wrap gap-1 pt-3">
            {badges.map(badge => (
                <PopupButton
                    key={badge.name}
                    darkMode={true}
                    minPopupWidthPx={200}
                    buttonContent={(
                        <Pill className={badge.colourClasses}>
                            {badge.name}
                        </Pill>
                    )}>

                    <p className="mb-1 font-bold">{badge.name}</p>
                    <p className="mb-0 text-body">{badge.title}</p>
                </PopupButton>
            ))}
        </div>
    );
}
